import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useDispatch, useSelector } from "react-redux";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import {
  setEditedVideoPosition,
  setOpenNameDialog,
  setEditedVideoName,
} from "../../../Redux/Actions/VideoHighlightAction";

export default function NameDialog({ merge }) {
  const dispatch = useDispatch();
  const [choice, setChoice] = useState("replace");
  const [videoName, setVideoName] = useState("");
  const [defaultVideoName, setDefaultVideoName] = useState("");

  const { isNameDialog, selectedVideoPaths } = useSelector(
    (state) => state?.videoHighlightData
  );

  useEffect(() => {
    if (isNameDialog) {
      const selectedVideoName =
        selectedVideoPaths[0]?.videoName &&
        (selectedVideoPaths[0]?.videoName.endsWith(".m3u8") ||
          selectedVideoPaths[0]?.videoName.endsWith(".mp4"))
          ? selectedVideoPaths[0]?.videoName.substring(
              0,
              selectedVideoPaths[0]?.videoName.lastIndexOf(".")
            )
          : selectedVideoPaths[0]?.videoName;
      setDefaultVideoName(selectedVideoName);
      setVideoName(selectedVideoName);
      setEditedVideoName(dispatch, `${selectedVideoName}.mp4`);
    }

    return () => {
      setChoice("replace");
      setVideoName("");
    };
  }, [isNameDialog, selectedVideoPaths, dispatch]);

  const handleClose = async () => {
    setOpenNameDialog(dispatch, false);
    merge();
  };

  const handleValueEvent = (e) => {
    const str = e.target.value.replace(/\s+/g, "");
    setVideoName(str);
    setEditedVideoName(dispatch, `${str}.mp4`);
  };

  const handleCancel = () => {
    setOpenNameDialog(dispatch, false);
  };

  const handleChoiceChange = (e) => {
    const selectedChoice = e.target.value;
    setChoice(selectedChoice);
    setEditedVideoPosition(dispatch, selectedChoice);
    if (selectedChoice === "replace") {
      setVideoName(`${defaultVideoName}.mp4`);
      setEditedVideoName(dispatch, `${defaultVideoName}.mp4`);
    }
  };

  return (
    <Dialog open={isNameDialog} onClose={handleClose}>
      <DialogTitle>Video Handling Options</DialogTitle>
      <DialogContent>
        <RadioGroup
          aria-label="choice"
          name="choice"
          value={choice}
          onChange={handleChoiceChange}
        >
          <FormControlLabel
            value="replace"
            control={<Radio />}
            label="Replace the video"
          />
          <FormControlLabel
            value="add"
            control={<Radio />}
            label="Add to a highlight section"
          />
        </RadioGroup>
        <DialogContentText>
          Enter the name you want to give to the edited video:
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          type="text"
          fullWidth
          variant="standard"
          value={videoName}
          onChange={handleValueEvent}
          placeholder="ex. Highlight1"
          disabled={choice === "replace"}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Ok</Button>
        <Button onClick={handleCancel}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
